module.exports = __webpack_public_path__ + "img/transfer28.3dd6e1cb.jpeg";